import React from 'react';
import ImageWithCache from './ImageWithCache';
import Navbar from './Navbar';
import './CreditPage.css';
import { getStoredChatId } from './chatId';
import seededRandom from './seededRandom';

// Доступний ліміт — «згенерований» для кожного користувача: від 2 000 до
// 50 000 ₴ із кроком 500, стабільний (прив'язаний до chatId)
function generateCreditLimit(seed) {
  const rand = seededRandom(`${seed}-credit-limit`);
  return 2000 + Math.floor(rand() * 97) * 500;
}

function formatLimit(value) {
  const [intPart, decimalPart] = value.toFixed(2).split('.');
  return `${intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}.${decimalPart} ₴`;
}

const CreditPage = () => {
  const creditLimit = generateCreditLimit(getStoredChatId() || 'guest');

  return (
    <div className="credit-page">
      <div className="credit-content">
        <div className="credit-hero">
          <div className="credit-hero-top">
            <ImageWithCache className="credit-hero-icon" src="/credit-icons/credit-setings.webp" alt="Налаштування" />
            <p className="credit-hero-title">Доступний ліміт</p>
            <ImageWithCache className="credit-hero-icon" src="/credit-icons/credit-info.webp" alt="Інформація" />
          </div>
          <p className="credit-hero-balance">{formatLimit(creditLimit)}</p>
        </div>

        <div className="credit-card credit-card-big">
          <div className="credit-card-icon">
            <ImageWithCache className="credit-card-icon-img" src="/credit-icons/credit-paw.webp" alt="Покупка частинами" />
          </div>
          <p className="credit-card-title">Покупка Частинами</p>
          <p className="credit-card-subtitle">В маркеті все від <span>10 платежів</span></p>
          <ImageWithCache className="credit-card-cat" src="/credit-icons/credit-cat.webp" alt="" />
        </div>

        <div className="credit-row">
          <div className="credit-card credit-card-small">
            <div className="credit-card-icon">
              <ImageWithCache className="credit-card-icon-img" src="/credit-icons/credit-credit.webp" alt="Розстрочка на картку" />
            </div>
            <p className="credit-card-title">Розстрочка<br />на картку</p>
          </div>
          <div className="credit-card credit-card-small">
            <div className="credit-card-icon">
              <ImageWithCache className="credit-card-icon-img" src="/credit-icons/credit-calendar.webp" alt="Кредит «До завтра»" />
            </div>
            <p className="credit-card-title">Кредит<br />«До завтра»</p>
          </div>
        </div>
      </div>
      <Navbar />
    </div>
  );
};

export default CreditPage;
